import { computed } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    CardItem,
    getWeatherIcon,
    humanizeString,
    inject,
    StatusCard,
    scaleLevel,
} from 'Mri.Web.Common';
import * as React from 'react';
import { WeatherStore } from '../../../Weather/WeatherStore';
import { ActiveDisplay } from '../../ActiveDisplay';

export interface IDisplayWeatherCardProps {
    readonly display: ActiveDisplay;
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
    readonly loading: boolean;
}

@autoinject
@observer
export class DisplayWeatherCard extends React.Component<IDisplayWeatherCardProps> {
    public render() {
        const weather = this.props.statusPoll?.weatherVuStatus;
        if (!weather) return;
        return (
            <StatusCard
                title={
                    <span>
                        Weather <img className="weather-card-icon" src={this.weatherIcon} width={70} height={70} />
                    </span>
                }
            >
                {this.displayWeather?.weather && (
                    <>
                        <CardItem label="Weather" value={humanizeString(this.displayWeather.weather[0].description)} />
                        <CardItem
                            label="Temperature"
                            value={(this.displayWeather.main.temp - 273.15).toFixed(1) + ' ℃'}
                        />
                    </>
                )}
                <CardItem
                    label="Cloud Cover Ratio"
                    value={weather.cloudIndex != null ? scaleLevel(weather.cloudIndex) + '%' : '-'}
                />
                <CardItem
                    label="Barometric Pressure"
                    value={
                        <span>{weather.barometricPressure != null ? weather.barometricPressure + ' hPa' : '-'}</span>
                    }
                />
                <CardItem
                    label="Local Humidity"
                    value={weather.localHumidity != null ? scaleLevel(weather.localHumidity) + '%' : '-'}
                />
                <CardItem label="Wind Speed" value={weather.windSpeed != null ? weather.windSpeed + ' m/s' : '-'} />
                <CardItem
                    label="Wind Direction"
                    value={weather.windDirection != null ? weather.windDirection + '°' : '-'}
                />
                <CardItem label="Wind Gust" value={weather.windGust != null ? weather.windGust + ' m/s' : '-'} />
                <CardItem label="Rain 1 Hour" value={weather.rain1Hour != null ? weather.rain1Hour + ' mm' : '-'} />
                <CardItem label="Rain 3 Hours" value={weather.rain3Hours != null ? weather.rain3Hours + ' mm' : '-'} />
                <CardItem label="Snow 1 Hour" value={weather.snow1Hour != null ? weather.snow1Hour + ' mm' : '-'} />
                <CardItem label="Snow 3 Hours" value={weather.snow3Hours != null ? weather.snow3Hours + ' mm' : '-'} />
            </StatusCard>
        );
    }

    @computed
    private get weatherIcon() {
        const icon = (this.displayWeather?.weather && this.displayWeather.weather[0]?.icon) ?? '';
        return getWeatherIcon(icon);
    }

    @computed
    private get displayWeather() {
        return this.weatherStore.weathers.get(this.props.display.serialNumber);
    }

    @inject
    private weatherStore!: WeatherStore;
}
